'use client'

import React from 'react'
import { Section } from '@/components/Section'
import { Heading } from '@/components/ui/heading'
import { Eyebrow } from '@/components/Eyebrow'
import { Subheading } from '@/components/ui/subheading'
import { StatsCard } from '@/components/StatsCard'
import { ShardGrid } from '@/components/ShardGrid'
import { HowPricingWorksBlock } from '@/payload-types'
import RichText from '@/components/RichText'

export function HowPricingWorksClient(
  props: HowPricingWorksBlock & {
    pricingStats: {
      storage3xMedian: string
      uploadMedian: string
      downloadMedian: string
    }
  },
) {
  return (
    <Section px={false} bgClassName="bg-paper-1">
      <div className="flex flex-col md:flex-row gap-[50px]">
        <div className="flex-1 flex flex-col gap-[50px] overflow-hidden px-4">
          <Heading size="h2" className="text-balance">
            {props.heading}
          </Heading>
          <div className="grid grid-cols-1 lg:grid-cols-2 2xl:grid-cols-4 gap-x-8 gap-y-[40px] w-full overflow-hidden">
            {props.hows?.map((how) => (
              <div key={how.title} className="flex items-start gap-[20px]">
                <div className="pt-2">
                  <Eyebrow color="slime" variant="dark" />
                </div>
                <div className="flex flex-col gap-2">
                  <Subheading size="md" className="text-balance">
                    {how.title}
                  </Subheading>
                  <RichText data={how.description} />
                </div>
              </div>
            ))}
          </div>
          <div className="pt-[20px] hidden xl:block h-[80px] 2xl:h-[150px] w-full">
            <ShardGrid />
          </div>
        </div>
        <div className="pt-[50px] px-4">
          <StatsCard
            variant="olive"
            eyebrow={{ label: 'Median pricing', color: 'slime' }}
            stats={[
              { label: 'storage at 3X redundancy', value: props.pricingStats.storage3xMedian },
              { label: 'upload', value: props.pricingStats.uploadMedian },
              { label: 'download', value: props.pricingStats.downloadMedian },
            ]}
          />
        </div>
      </div>
    </Section>
  )
}
